import { CustomersScorecardDTO } from '../dtos/customers-scorecards-DTO';
import { CustomersScorecardTable } from '../views/customers-scorecard-table';
import {
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
} from '../../utils/commonUtils/validation-utils';
import { CAMEL_CASE } from '../../utils/stringUtils/index';
import { IS_NOT_EMPTY } from '../../utils/stringUtils/string-utils';

export const CUSTOMERS_SCORECARDS_TABLE = (
	lanesList: Array<CustomersScorecardDTO> = []
): Array<CustomersScorecardTable> => {
	let results: Array<CustomersScorecardTable> = [];
	if (lanesList.length > 0) {
		lanesList.map((load) => {
			let row = {} as CustomersScorecardTable;
			row.customerName = '';
			row.customerId = load.customerId;
			row.accountExecsId = load.accountExecsId;
			row.accountExecutive = `${CAMEL_CASE(load.firstName)} ${CAMEL_CASE(load.lastName)}`;
			row.carriersCount = load.carriersCount;
			row.loadsCount = load.loadsCount;
			row.allInCost = load.allInCost;
			row.predictedPrice = load.predictedPrice;
			row.totalBuy = IS_NOT_NULL_OR_UNDEFINED(row.allInCost) ? row.allInCost / 100 : null;
			row.forecastBuy = IS_NOT_NULL_OR_UNDEFINED(row.predictedPrice)
				? row.predictedPrice / 100
				: null;
			row.expectedMargin = IS_NOT_NULL_OR_UNDEFINED(load.expectedMargin)
				? load.expectedMargin / 100
				: null;
			row.actualMargin = IS_NOT_NULL_OR_UNDEFINED(load.actualMargin)
				? load.actualMargin / 100
				: null;
			row.percentOfRevenue = null;
			row.targetRevenue =
				IS_NOT_NULL_OR_UNDEFINED(load.targetRevenue) && load.targetRevenue > 0
					? load.targetRevenue / 100
					: 0;
			row.customerName = IS_NULL_OR_UNDEFINED(load.customerId)
				? 'Unidentified'
				: IS_NOT_EMPTY(load.customerName)
				? load.customerName
				: 'N/A';
			row.revenue = IS_NOT_NULL_OR_UNDEFINED(load.priceToShipper)
				? load.priceToShipper / 100
				: null;
			results.push(row);
		});
	}
	return results;
};
